(() => {
  const desktopMenus = new Map();
  const mobileMenus = new Map();
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const connectDesktop = (nav) => {
    if (desktopMenus.has(nav)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const dropdowns = [...nav.querySelectorAll('[data-bloom-dropdown]')];
    let active = null;
    let hoverOpened = null;
    let hoverTimer;
    let leaveTimer;
    const close = (restoreFocus = false) => {
      clearTimeout(hoverTimer);
      clearTimeout(leaveTimer);
      hoverOpened = null;
      if (!active) return;
      const summary = active.querySelector('summary');
      active.open = false;
      active = null;
      if (restoreFocus) summary.focus();
    };
    const open = (dropdown, fromHover = false) => {
      clearTimeout(hoverTimer);
      clearTimeout(leaveTimer);
      dropdowns.forEach((other) => {
        if (other !== dropdown) other.open = false;
      });
      dropdown.open = true;
      active = dropdown;
      hoverOpened = fromHover ? dropdown : null;
    };
    dropdowns.forEach((dropdown) => {
      const summary = dropdown.querySelector('summary');
      summary.setAttribute('aria-expanded', String(dropdown.open));
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (!dropdown.open || (hoverOpened === dropdown && event.detail > 0)) {
          open(dropdown);
        } else {
          close();
          dropdown.open = false;
        }
      }, options);
      dropdown.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(dropdown.open));
        if (dropdown.open && active !== dropdown) open(dropdown);
        else if (!dropdown.open && active === dropdown) {
          active = null;
          if (hoverOpened === dropdown) hoverOpened = null;
        }
      }, options);
      dropdown.addEventListener('pointerenter', () => {
        if (!finePointer.matches) return;
        clearTimeout(leaveTimer);
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          if (!dropdown.open) open(dropdown, true);
        }, 130);
      }, options);
      dropdown.addEventListener('pointerleave', () => {
        if (!finePointer.matches) return;
        clearTimeout(hoverTimer);
        leaveTimer = setTimeout(() => {
          if (!dropdown.contains(document.activeElement)) close();
        }, 180);
      }, options);
    });
    nav.addEventListener('focusout', (event) => {
      if (!nav.contains(event.relatedTarget)) close();
    }, options);
    document.addEventListener('pointerdown', (event) => {
      if (!nav.contains(event.target)) close();
    }, options);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && active) {
        event.preventDefault();
        close(true);
      }
    }, options);
    desktopMenus.set(nav, () => {
      close();
      controller.abort();
      desktopMenus.delete(nav);
    });
  };

  const connectMobile = (root) => {
    if (mobileMenus.has(root)) return;
    const trigger = root.querySelector('[data-bloom-menu-open]');
    const dialog = root.querySelector('[data-bloom-menu-dialog]');
    if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
    const closeButton = dialog.querySelector('[data-bloom-menu-close]');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let previousOverflow;
    let focusBeforeOpen;
    let locked = false;
    const unlock = (restoreFocus = true) => {
      if (!locked) return;
      document.body.style.overflow = previousOverflow;
      trigger.setAttribute('aria-expanded', 'false');
      locked = false;
      if (restoreFocus && focusBeforeOpen?.isConnected) focusBeforeOpen.focus();
    };
    const close = () => {
      if (dialog.open) dialog.close();
      unlock();
    };
    trigger.addEventListener('click', () => {
      if (dialog.open) return;
      focusBeforeOpen = document.activeElement;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      locked = true;
      trigger.setAttribute('aria-expanded', 'true');
      closeButton.focus();
    }, options);
    closeButton.addEventListener('click', close, options);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    }, options);
    dialog.addEventListener('close', () => unlock(), options);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    }, options);
    const desktopBreakpoint = window.matchMedia('(min-width: 990px)');
    desktopBreakpoint.addEventListener('change', (event) => {
      if (event.matches) close();
    }, options);
    mobileMenus.set(root, () => {
      if (dialog.open) dialog.close();
      unlock(false);
      controller.abort();
      mobileMenus.delete(root);
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-bloom-desktop-nav]').forEach(connectDesktop);
    scope.querySelectorAll('[data-bloom-mobile-nav]').forEach(connectMobile);
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    [...desktopMenus, ...mobileMenus].forEach(([root, disconnect]) => {
      if (event.target.contains(root)) disconnect();
    });
  });
})();
